import { registerPlugin } from '@capacitor/core';
import type { PlanItem } from '@hmawiw/shared';

export interface TimerItem {
  id: number;
  kind: 'timer';
  title: string;
  body: string;
  cardId: string;
  at: number;
  ring: boolean;
}

interface NotifierPlugin {
  /** What the background job needs to ask the server for a plan while the app is closed. */
  configure(options: { server: string; token: string; lang: string; today: boolean; done: string }): Promise<void>;
  /** The plan derived while the app runs; the notifier diffs it against the last one. */
  apply(options: { items: PlanItem[] }): Promise<void>;
  /** With no item the timer is cleared. */
  setTimer(options: { item?: TimerItem }): Promise<void>;
  /** On while changes wait to be pushed: the background job must not replace this phone's newer plan with the server's. */
  hold(options: { on: boolean }): Promise<void>;
  /** Signed out: every notification, alarm and stored credential goes. */
  clear(): Promise<void>;
}

/** Local Android plugin (NotifierPlugin.java in client/android); only the Android shell implements it. */
export const Notifier = registerPlugin<NotifierPlugin>('Notifier');
